
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/topBar/dropPanel/promotionalPanel/linksList.scss.css.virtualfile';
        module.exports = {"linksListItem":"_linksListItem_1sezl_7","text":"_text_1sezl_13","symbolContainer":"_symbolContainer_1sezl_17"};